<template>
  <div :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
    <!-- TheHeader and TheFooter will only be displayed if the route doesn't have meta.hideLayout set to true -->
    <TheHeader v-if="!$route.meta.hideLayout" />
    
    <router-view/>
    
    <TheFooter v-if="!$route.meta.hideLayout" />
  </div>
</template>

<script>
import TheHeader from './components/TheHeader.vue';
import TheFooter from './components/TheFooter.vue';

export default {
  name: 'App',
  components: { TheHeader, TheFooter }
}
</script>